import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { PaymentApi, PaymentApiImpl } from './apis';

export const paymentContainer = new ContainerModule((bind) => {
  bind(PaymentApi).to(PaymentApiImpl);
});

export { PaymentApi } from './apis';
export {
  STAGE_MSE_PRO_MONTHLY,
  STAGE_MSE_PRO_YEARLY,
  US_MSE_PRO_MONTHLY,
  US_MSE_PRO_YEARLY,
  EU_MSE_PRO_MONTHLY,
  EU_MSE_PRO_YEARLY,
} from './constants';
export type { ICreatePaymentSessionRequest, ICreatePaymentSessionResponse } from './types';
